import axios from "axios";

const wadoRoot = () => {
  return `${window.config.dataSources[0].configuration['wadoRoot']}/studies`;
}

export class ImagemService {

  getImagensChave(STUDYUID_FKEY, SERIESUID_FKEY) {
    try {
      return axios.get(`${wadoRoot()}/${STUDYUID_FKEY}/${SERIESUID_FKEY}/getImagesKeyBySeriesLevel`);
    } catch (error) {
      console.log(error);
    }
  }

  putImageKey(VALUE, STUDYUID_FKEY, SERIESUID_FKEY, INSTANCEUID) {
    try {
      return axios.put(`${wadoRoot()}/${VALUE}/${STUDYUID_FKEY}/${SERIESUID_FKEY}/${INSTANCEUID}/putimagemimpressao`);
    }
    catch (error) {
      console.log(error);
    }
  }

  postImagemSecundaria(imagemSecundariaDTO) {
    try {
      var formdata = new FormData();
      formdata.append('InstanceUid', imagemSecundariaDTO.InstanceUid);
      formdata.append('Image', imagemSecundariaDTO.Image);
      return axios.post(`${wadoRoot()}/postGerarImagemSecundaria`, formdata);
    } catch (error) {
      console.log(error);
    }
  }

  getSeriesMetadataCount(StudyUid, SerieUid, minInstance, maxInstance, jsonInstances) {
    //return axios.get(`${wadoRoot()}/${StudyUid}/series/${SerieUid}/minCount/${minInstance}/maxCount/${maxInstance}/metadata`);
    try {
      var XHTTP = new XMLHttpRequest();
      XHTTP.open("GET", `${wadoRoot()}/${StudyUid}/series/${SerieUid}/minCount/${minInstance}/maxCount/${maxInstance}/metadata`, false);
      XHTTP.send();
      const instancesJSON = JSON.parse(XHTTP.responseText);
      instancesJSON.forEach(obj => {
        jsonInstances.push(obj);
      });
    } catch (ex) {
      console.error(ex);
    }
  }

}
